import { useMemo } from 'react';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useApiClient } from '@m43/core';
import { EventSearchBootstrapResponse, CadSearchResource } from '@mark43/cad-api';

export type EnsuredQueryResult<TData> = Omit<UseQueryResult<TData>, 'data'> & { data: TData };

const emptyOptions: EventSearchBootstrapResponse = {
    eventSearchSharingOptions: {
        departmentRoleOptions: [],
        operationTypeOptions: [],
    },
    eventSearchOptions: {
        agencyProfileOptions: [],
        agencyTypeOptions: [],
        callForServiceOptions: [],
        callSignOptions: [],
        countryCodeOptions: [],
        dispatchAreaOptions: [],
        dispatchedOptions: [],
        dispositionOptions: [],
        eventLabelOptions: [],
        eventOriginOptions: [],
        eventQueueOptions: [],
        eyeColorOptions: [],
        groupedSubdivisionOptions: [],
        hairColorOptions: [],
        hospitalOptions: [],
        itemColorOptions: [],
        locationVerificationOptions: [],
        personInvolvementTypeOptions: [],
        priorityOptions: [],
        raceOptions: [],
        radioChannelOptions: [],
        reportingEventNumberGeneratedOptions: [],
        selfInitiatedOptions: [],
        sexOptions: [],
        stateOptions: [],
        timeRangeOptions: [],
        towTypeOptions: [],
        vehicleInvolvementTypeOptions: [],
        firearmMakeOptions: [],
        itemCategoryOptions: [],
        itemTypeOptions: [],
        hasAttachmentsOptions: [],
        attachmentTypeOptions: [],
        attachmentCategoryOptions: [],
    },
    eventSearchStatics: {
        reportingEventNumberDisplayName: '',
    },
};

export function useEventSearchBootstrap(): EnsuredQueryResult<EventSearchBootstrapResponse> {
    const apiClient = useApiClient();

    const query = useQuery(
        ['event-search-bootstrap'],
        async () => {
            const resp = await apiClient.request<CadSearchResource.GetEventSearchBootstrap>({
                method: 'POST',
                url: 'cad_search/event/bootstrap',
                data: {},
            });
            return resp.data.data;
        },
        { refetchOnMount: false, cacheTime: Infinity, staleTime: Infinity }
    );

    return useMemo(() => {
        return {
            ...query,
            data: query.data ? query.data : emptyOptions,
        } as EnsuredQueryResult<EventSearchBootstrapResponse>;
    }, [query]);
}
